import React from 'react';
import { Link,  } from 'react-router-dom';
import Button from '../../../components/common/Button';
import './NotFoundPage.scss';

const NotFoundPage = () => {
    return (
        <div className="not-found-page">
            <div className="not-found-content">
                <h1>404</h1>
                <h2>Page Not Found</h2>
                <p>The page you're looking for doesn't exist or has been moved.</p>
                <div className="not-found-actions">
                    <Button as={Link} to="/resources" variant="primary">
                        Go to Dashboard
                    </Button>
                    <Button as={Link} to="/" variant="secondary">
                        Go Home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;